import { store } from '../../store'
import { plainToClass } from 'class-transformer'
import { GetQuizDTO } from '../../dto/quizes'
import { validate } from 'class-validator'

export const getTest = async ( id: number ) => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/tests/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'GET'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_QUIZ_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_QUIZ_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_QUIZ_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetQuizDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_QUIZ_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_QUIZ_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'SET_QUIZ_TYPE', quizType: `test` } )
    store.dispatch( { type: 'GET_QUIZ_OK', quiz: body.quiz } )

}